import React, { useState, useEffect } from "react";
import { func, bool, array, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CloseIcon from "../atoms/icons/close";
import DfpAd from "../dfp-ad";

import { setTopAndBottomAd, setTopAd } from "../helper/actions";

import "./breakingNewsSlider.m.css";

const BreakingNewsSliderView = (props) => {  
  const [closeAd, setCloseAd] = useState(true);
  const [isScroll, setIsScroll] = useState(false);
  const [adShow, setAdShow] = useState(false);
  const [scrollUpPosition, setScrollUpPosition] = useState(null);
  const [isBottomAd, setBottomAd] = useState(true);

  useEffect(() => {
    if (
      window &&
      (window.location.href.includes("auth.prothomalo") || window.location.href.includes("auth-uat.prothomalo"))
    ) {
      setBottomAd(false);
    }
  }, []);

  useEffect(() => {
    setScrollUpPosition(global.deviceWidth > 876 ? "90px" : "60px");

    document.addEventListener("scroll", () => {
      const isScrollAxis = scrollY > 200;
      if (global.deviceWidth > 876 && scrollY >= 400) {
        props.setTopAndBottomAd(true);
      } else if (global.deviceWidth < 876 && scrollY >= 300) {
        props.setTopAndBottomAd(true);
      } else {
        props.setTopAndBottomAd(false);
      }

      if (isScrollAxis !== isScroll) {
        setIsScroll(true);
        setAdShow(true);
      }
    });
    return () => {
      setCloseAd(true);
      setIsScroll(true);
      setAdShow(false);
    };
  }, []);

  const { publisherAttributes, pageType, showAd } = props;

  // ADS logic Start
  const getAdType = () => {
    switch (pageType) {
      case "home-page":
        return publisherAttributes.lang === "en" ? "EnPalo_HP_Floating_970x90" : "Mobile_HP_Anchor";
      case "section-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      case "collection-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      case "story-page":
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
      default:
        return publisherAttributes.lang === "en" ? "EnPalo_Inner_Floating_970x90" : "Mobile_Article_Anchor";
    }
  };
  const scrollUp = { bottom: showAd && closeAd ? scrollUpPosition : 0 };
  const scrollUpAd = { bottom: isScroll || adShow ? 0 : "-138px" };

  const closeAdBlock = () => {
    setCloseAd(false);
  };
  // ADS logic End

  const bottomAdComponent = () => (
    <div
      className="ad-bottom-container"
      styleName={`ad-bottom ${showAd && closeAd ? "show-ad" : ""}`}
      style={scrollUpAd}
    >
      <div styleName="ad-bottom-wrapper">
        <div title="close" styleName="breaking-close ad-close" onClick={() => closeAdBlock()}>
          <CloseIcon />
        </div>
        <div styleName="ad-wrapper">
          <DfpAd adtype={getAdType()} slotId="breaking-news-slider-ad" />
        </div>
      </div>
    </div>
  );

  return (
    <div>      
      {isBottomAd && showAd && bottomAdComponent()}
    </div>
  );
};

BreakingNewsSliderView.propTypes = {  
  publisherAttributes: object,
  setTopAndBottomAd: func,
  showAd: bool,
  pageType: string,
  setTopAd: func,
  isTopAd: bool,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  showAd: get(state, ["TopAndBottomAdReducer", "showAd"], false),
  pageType: get(state, ["qt", "pageType"], ""),
  isTopAd: get(state, ["topAdReducer", "isTopAd"], true),
});

const mapDispatchToProps = (dispatch) => ({
  setTopAndBottomAd: (flag) => dispatch(setTopAndBottomAd(flag)),
  setTopAd: (flag) => dispatch(setTopAd(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreakingNewsSliderView);
